import { render, staticRenderFns } from "./ShortcutsDialog.vue?vue&type=template&id=7160a4e7&scoped=true&"
import script from "./ShortcutsDialog.vue?vue&type=script&lang=js&"
export * from "./ShortcutsDialog.vue?vue&type=script&lang=js&"
import style0 from "./ShortcutsDialog.vue?vue&type=style&index=0&id=7160a4e7&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7160a4e7",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VCardTitle } from 'vuetify/lib/components/VCard';
import { VDialog } from 'vuetify/lib/components/VDialog';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSpacer } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCard,VCardActions,VCardText,VCardTitle,VDialog,VIcon,VSpacer})


/* hot reload */
if (module.hot) {
  var api = require("/home/semaphore/fabric-client/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('7160a4e7')) {
      api.createRecord('7160a4e7', component.options)
    } else {
      api.reload('7160a4e7', component.options)
    }
    module.hot.accept("./ShortcutsDialog.vue?vue&type=template&id=7160a4e7&scoped=true&", function () {
      api.rerender('7160a4e7', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/panoViewer/components/ShortcutsDialog.vue"
export default component.exports